import { render, staticRenderFns } from "./relationb.vue?vue&type=template&id=4f85ab21&scoped=true&"
import script from "./relationb.vue?vue&type=script&lang=js&"
export * from "./relationb.vue?vue&type=script&lang=js&"
import style0 from "./relationb.vue?vue&type=style&index=0&id=4f85ab21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85ab21",
  null
  
)

export default component.exports